module.exports = __webpack_public_path__ + "img/dynamic_1.e032dde6.png";